import { phpRequest } from "./phpRequest";

export const getCompanyAccountsAPI = async (company_id) => {
  const data = await phpRequest.get("/company/accounts", {
    company_id,
  });
  return data.users;
};
